import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  computed,
  inject,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface iconInterface {
  icon: string;
  width?: string | number;
  height?: string | number;
  stroke?: string;
  fill?: string;
  background?: string;
}

@Component({
  selector: 'icon-induxtry',
  templateUrl: './icon-induxtry.component.html',
  styleUrls: ['./icon-induxtry.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})


export class IconInduxtryComponent implements AfterViewInit, OnDestroy {
  icon = input<iconInterface>();
  iconConfig = computed<iconInterface>(() => this.icon());
  iconWidth = computed<string>(() => this.toCssSize(this.iconConfig()?.width));
  iconHeight = computed<string>(() => this.toCssSize(this.iconConfig()?.height));
  iconStroke = computed<string>(() => this.iconConfig()?.stroke);
  iconFill = computed<string>(() => this.iconConfig()?.fill);
  hasStrokeKey = computed<boolean>(() => {
    const config = this.iconConfig();
    if (!config) return false;
    return Object.prototype.hasOwnProperty.call(config, 'stroke');
  });
  hasFillKey = computed<boolean>(() => {
    const config = this.iconConfig();
    if (!config) return false;
    return Object.prototype.hasOwnProperty.call(config, 'fill');
  });

  private readonly statusIconPathMap: Record<string, string> = {
    'tube-spinner': 'assets/icons/loading/tube-spinner.svg',
    'circle-success': 'assets/icons/feedback/circle_success.svg',
    'circle-cancel': 'assets/icons/feedback/circle-cancel.svg',
    'queue': 'assets/icons/common/queue.svg',
  };

  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly ngZone = inject(NgZone);
  private readonly el = inject(ElementRef<HTMLElement>);
  private observer?: MutationObserver;

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.observer = new MutationObserver(() => {
        this.ngZone.run(() => this.cdRef.markForCheck());
      });
      this.observer.observe(this.el.nativeElement, {
        childList: true,
        subtree: true,
      });
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  get useImgFallback(): boolean {
    return Boolean(this.statusIconPathMap[this.iconConfig()?.icon]);
  }

  get iconImgSrc(): string | null {
    return this.statusIconPathMap[this.iconConfig()?.icon] ?? null;
  }

  private toCssSize(value: string | number | undefined): string {
    if (value == null || value === '') return '24px';
    if (typeof value === 'number') return `${value}px`;
    return value;
  }
}
